'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct4 from "./scala.-Product4.js";
var $p;
/** @constructor */
function $c_T4(_1, _2, _3, _4) {
  this.ke = null;
  this.h0 = null;
  this.kf = null;
  this.iU = null;
  this.ke = _1;
  this.h0 = _2;
  this.kf = _3;
  this.iU = _4;
}
export { $c_T4 as $c_T4 };
$p = $c_T4.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T4;
/** @constructor */
function $h_T4() {
}
export { $h_T4 as $h_T4 };
$h_T4.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 4;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct4.$f_s_Product4__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-1542739752), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T4) && ((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.ke, x$0.ke) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.h0, x$0.h0)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.kf, x$0.kf)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.iU, x$0.iU))));
});
$p.o = (function() {
  return "Tuple4";
});
$p.b = (function() {
  return (((((((("(" + this.ke) + ",") + this.h0) + ",") + this.kf) + ",") + this.iU) + ")");
});
function $isArrayOf_T4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eO)));
}
export { $isArrayOf_T4 as $isArrayOf_T4 };
var $d_T4 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T4, "scala.Tuple4", ({
  eO: 1,
  b: 1,
  c: 1,
  rX: 1,
  a: 1
}));
export { $d_T4 as $d_T4 };
